import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class PaymentLinkShowRoute extends Route {
  @service router;
  @service fastboot;
  @service currentPractice;
  @service paymentLinkState;

  async beforeModel() {
    if (this.fastboot.isFastBoot) {
      return;
    }
    if (!this._areFeatureFlagsEnabled()) {
      return this.router.transitionTo('not-found', 'errors/404');
    }

    await this.paymentLinkState.requirePaymentLinkSession();
  }

  _areFeatureFlagsEnabled() {
    return (
      this.currentPractice.get('featurePaymentLinksSms') &&
      this.currentPractice.get('featurePaymentLinks')
    );
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.set('paymentLinkSession', this.paymentLinkState.paymentLinkSession);
  }
}
